import { useEffect, useState, useCallback } from 'react'
import { platformService } from '@/services/platformService'

type Svc = { name: string; endpoint: string; up: boolean; latencyMs: number }

export default function PlatformHealthPage() {
    const [services, setServices] = useState<Svc[]>([])
    const [loading, setLoading] = useState(true)

    const load = useCallback(() => {
        setLoading(true)
        platformService.healthServices().then(setServices).catch(() => setServices([])).finally(() => setLoading(false))
    }, [])

    useEffect(() => {
        load()
        const t = setInterval(load, 15000) // auto-refresh cada 15s
        return () => clearInterval(t)
    }, [load])

    const upCount = services.filter((s) => s.up).length

    return (
        <div>
            <div className="mb-6 flex items-center justify-between">
                <h1 className="text-2xl font-semibold">Salud de servicios</h1>
                <div className="flex items-center gap-4">
                    <span className="text-sm text-slate-400">{upCount}/{services.length} operativos</span>
                    <button onClick={load} className="rounded-md border border-slate-700 px-3 py-1.5 text-sm text-slate-300 hover:bg-slate-800">Refrescar</button>
                </div>
            </div>

            {loading && services.length === 0 ? (
                <div className="text-slate-400">Sondeando…</div>
            ) : (
                <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
                    {services.map((s) => (
                        <div key={s.name} className="flex items-center justify-between rounded-xl border border-slate-800 bg-slate-800/50 p-4">
                            <div className="min-w-0">
                                <div className="truncate font-medium text-slate-100">{s.name}</div>
                                <div className="truncate font-mono text-xs text-slate-500">{s.endpoint} · {s.latencyMs}ms</div>
                            </div>
                            <span className={`ml-3 flex shrink-0 items-center gap-1.5 text-sm ${s.up ? 'text-emerald-400' : 'text-rose-400'}`}>
                                <span className={`inline-block h-2.5 w-2.5 rounded-full ${s.up ? 'bg-emerald-400' : 'bg-rose-400'}`} />
                                {s.up ? 'OK' : 'CAÍDO'}
                            </span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    )
}
